import { FilterVariantIcon } from './FilterVariantIcon';

/**
 * author: Google
 * id AECECEA4-9E56-4B4B-ACD6-2C85AB09788A
 * name filter-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-variant.svg
 * tags
 */
export const FilterListIcon = FilterVariantIcon;
export default FilterListIcon